/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
import { combineReducers } from 'redux';
// import { routerReducer } from 'react-router-redux'
// import {
//   firebaseStateReducer,
// } from 'react-redux-firebase'

import { firebaseReducer } from 'react-redux-firebase';
import { connectRouter } from 'connected-react-router';

import context from './contextReducer';
import command from './commandReducer';

// const history = require('history').createBrowserHistory();

// Combines all reducers to a single reducer function
const rootReducer = history => combineReducers({
  context,
  command,
  // router: routerReducer,
  router: connectRouter(history),
  firebase: firebaseReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js